export default __webpack_public_path__ + "static/media/ethan-buchman.80b1ff6e.jpeg";